import React, { useRef, useState, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import updateParams from "utils/updateParams.js";



export default function SaveChanges(props) {
  return (
    <button
      style={{
        paddingTop: "9px",
        paddingBot: "9px",
        paddingRight: "35px",
        paddingLeft: "35px",
      }}
      className="button b-type-primary b-color-green b-size-normal"
      as="input"
      type="submit"
      value="Save changes"
      variant="success"
      id="org-save-btn"
      >
        Save changes
    </button>
  );
}
